import { render, staticRenderFns } from "./NotificationSubscription.vue?vue&type=template&id=27de8da2"
import script from "./NotificationSubscription.vue?vue&type=script&lang=js"
export * from "./NotificationSubscription.vue?vue&type=script&lang=js"
import style0 from "./NotificationSubscription.vue?vue&type=style&index=0&id=27de8da2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports